module.exports = __webpack_public_path__ + "static/media/ic_requested_com.e6395e45.svg";